import type { RegistroDeAuditoria } from '@/lib/supabase/tipos-bd'

import { ACCIONES, DOCUMENTOS } from './frases'
import estilos from './PaginaAuditoria.module.css'

/**
 * LOS FILTROS: quién, qué acción, sobre qué documento y un buscador por
 * número o por lo que dice la nota. Todos se combinan.
 */
export type Filtros = {
  persona: string
  accion: RegistroDeAuditoria['tipo'] | ''
  documento: RegistroDeAuditoria['documento_tipo'] | ''
  buscar: string
}

export function FiltrosAuditoria({
  filtros,
  personas,
  onCambio,
}: {
  filtros: Filtros
  personas: string[]
  onCambio: (f: Filtros) => void
}) {
  const hayFiltro = Boolean(
    filtros.persona || filtros.accion || filtros.documento || filtros.buscar,
  )

  return (
    <div className={estilos.filtros}>
      <label className={estilos.campo}>
        <span>Quién</span>
        <select
          value={filtros.persona}
          onChange={(e) => onCambio({ ...filtros, persona: e.target.value })}
        >
          <option value="">Todas las personas</option>
          {personas.map((p) => (
            <option key={p} value={p}>
              {p}
            </option>
          ))}
        </select>
      </label>
      <label className={estilos.campo}>
        <span>Qué hizo</span>
        <select
          value={filtros.accion}
          onChange={(e) => onCambio({ ...filtros, accion: e.target.value as Filtros['accion'] })}
        >
          <option value="">Todas las acciones</option>
          {ACCIONES.map(([v, t]) => (
            <option key={v} value={v}>
              {t}
            </option>
          ))}
        </select>
      </label>
      <label className={estilos.campo}>
        <span>Sobre qué</span>
        <select
          value={filtros.documento}
          onChange={(e) =>
            onCambio({ ...filtros, documento: e.target.value as Filtros['documento'] })
          }
        >
          <option value="">Todos los documentos</option>
          {DOCUMENTOS.map(([v, t]) => (
            <option key={v} value={v}>
              {t}
            </option>
          ))}
        </select>
      </label>
      <label className={`${estilos.campo} ${estilos.campoAncho}`}>
        <span>Buscar</span>
        <input
          type="search"
          placeholder="OS-…, COT-…, OT-… o lo que dice la nota"
          value={filtros.buscar}
          onChange={(e) => onCambio({ ...filtros, buscar: e.target.value })}
        />
      </label>
      {hayFiltro && (
        <button
          type="button"
          className={estilos.limpiar}
          onClick={() => onCambio({ persona: '', accion: '', documento: '', buscar: '' })}
        >
          Quitar filtros ×
        </button>
      )}
    </div>
  )
}
